import React, { useState, useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import PersentageDonutChartWithBottomLegend
    from '../../ChartsImpl/DetailsPageCharts/PersentageDonutChartWithBottomLegend';
import toast, { Toaster } from "react-hot-toast";
import axios from 'axios';
import MUIDataTable from 'mui-datatables';
import CircularProgress from "@mui/material/CircularProgress";

// let myTimeout = null;

const WaitTimeExceptionDetails = (props) => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');

    const [chartValue, setChartValue] = useState(0);

    const [tokenData, settokenData] = useState([]);
    const [chartData, setchartData] = useState([]);

    const [isLoading, setLoading] = useState(false);
    const [count, setCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [categoryList, setcategoryList] = useState([]);
    const [percentageList, setpercentageList] = useState([]);

    const [tokenTableData, setTokenTableData] = useState([]);
    const [categoiesForRender, setCategoiesForRender] = useState([])

    const [update, setUpdate] = useState('1s')

    const [searchCategoryText, setSearchCategoryText] = useState('');

    const options = {
        tableBodyHeight: '50vh',
        filter: false,
        responsive: 'vertical',
        serverSide: false,
        count: count,
        download: false,
        viewColumns: false,
        jumpToPage: true,
        selectableRows: 'none',
        print: false,
        rowsPerPage: rowsPerPage,
        onChangeRowsPerPage: (n) => {
            setRowsPerPage(n)
        },
        rowsPerPageOptions: [10, 20, 30, 50, 100],
        setTableProps: () => {
            return {
                size: 'small',
            };
        }
    };

    const columns = [
        {
            label: 'Token No',
            name: 'ticketNo',
            options: {
                sort: true,
                filter: false
            }
        },
        {
            label: "Category",
            name: 'categoryName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: 'Language',
            name: 'language',
            options: {
                filter: false,
                sort: true
            }
        },
        {
            label: 'Issued time',
            name: 'issuedTime',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            label: 'Waiting time',
            name: 'waitTime',
            options: {
                filter: false,
                sort: true
            }
        },
        {
            label: 'KPI',
            name: 'kpi',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            label: 'Status',
            name: 'id',
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => {
                    if (tokenData === undefined) return;
                    let item = tokenData.find(item => item.id === value);
                    return (<>
                        {item.status === 1 ? <span className="badge custom-badge bg-blue ml-1 mb-2">serving</span>
                            : item.status === 2 ? <span className="badge custom-badge bg-warning ml-1 mb-2">no show</span>
                                : item.status === 3 ? <span className="badge custom-badge bg-warning ml-1 mb-2">waiting</span>
                                    : item.status === 4 ? (<span className="badge custom-badge bg-success ml-1 mb-2">served</span>)
                                        : item.status === 99 ? (<span className="badge custom-badge bg-danger ml-1 mb-2">canceled</span>)
                                            : (<span className="badge custom-badge bg-primary ml-1 mb-2">pending</span>)}
                    </>);
                }
            },
        }
    ];

    const columns_1 = [
        {
            label: "Branch",
            name: 'branchName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: 'Token No',
            name: 'ticketNo',
            options: {
                sort: true,
                filter: false
            }
        },
        {
            label: "Category",
            name: 'categoryName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: 'Language',
            name: 'language',
            options: {
                filter: false,
                sort: true
            }
        },
        {
            label: 'Issued time',
            name: 'issuedTime',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            label: 'Waiting time',
            name: 'waitTime',
            options: {
                filter: false,
                sort: true
            }
        },
        {
            label: 'KPI',
            name: 'kpi',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            label: 'Status',
            name: 'id',
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value) => {
                    if (tokenData === undefined) return;
                    let item = tokenData.find(item => item.id === value);
                    return (<>
                        {item.status === 1 ? (<span className="badge custom-badge badge-blue ml-1 mb-2">serving</span>)
                            : item.status === 2 ? <span className="badge custom-badge bg-warning ml-1 mb-2">no show</span>
                                : item.status === 3 ? <span className="badge custom-badge bg-warning ml-1 mb-2">waiting</span>
                                    : item.status === 99 ? (<span className="badge custom-badge bg-danger ml-1 mb-2">canceled</span>)
                                        : item.status === 4 ? (<span className="badge custom-badge bg-success ml-1 mb-2">served</span>)
                                            : (<span className="badge custom-badge bg-primary ml-1 mb-2">pending</span>)}
                    </>);
                }
            },
        }
    ];

    // useEffect(() => {
    //     const timer = setTimeout(() => getWaitingTicketDetails(), 10000);
    // }, []);

    useEffect(() => {
        let postsArray = JSON.parse(JSON.stringify(tokenData));
        let categoryData = [];
        postsArray.map((item, index) => {

            item.index = (
                <div>
                    {index + 1}
                </div>
            )

            if (item.status === 0) {
                item.status = "Waiting"
            } else if (item.status === 1) {
                item.status = "Serving"
            } else if (item.status === 2) {
                item.status = "No show"
            } else if (item.status === 3) {
                item.status = "Local waiting"
            } else if (item.status === 4) {
                item.status = "Served"
            }

            categoryData.push(item);
        });
        setTokenTableData(categoryData);
        setCategoiesForRender(categoryData);
    }, [tokenData]);


    useEffect(() => {
        if (props.showWaitTimeExceptionDetails === false) return;

        if (props.watingExeptionInc > 0 || props.messageInc1010 !== '' || props.messageInc1001 !== '' || props.messageInc1000 !== '') {
            getWaitingExceptionData();
        }
    }, [props.watingExeptionInc, props.messageInc1010, props.messageInc1000, props.messageInc1001]);

    useEffect(() => {
        setChartValue(chartValue + 1);
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            if (tokenData !== null && tokenData.length > 0) {
                for (let index = 0; index < tokenData.length; index++) {
                    const element = tokenData[index];
                    if (element.status === 0) {
                        element.waitTime = element.waitTimeFromSec + 5;
                        element.waitTimeFromSec = element.waitTimeFromSec + 5;

                        var hours = Math.floor(element.waitTime / 3600);
                        var minutes = Math.floor((element.waitTime - (hours * 3600)) / 60);
                        var seconds = element.waitTime - (hours * 3600) - (minutes * 60);

                        if (hours < 10) { hours = "0" + hours; }
                        if (minutes < 10) { minutes = "0" + minutes; }
                        if (seconds < 10) { seconds = "0" + seconds; }

                        element.waitTime = `${hours}:${minutes}:${seconds}`;
                    }
                }

                settokenData(tokenData);
                setUpdate(new Date().toString());
            }
        }, 5000);
        return () => clearInterval(interval);
    }, [tokenData]);

    // useEffect(() => {
    //     if (myTimeout != null)
    //         clearTimeout(myTimeout);
    // }, []);


    const getWaitingExceptionData = () => {
        console.log('getWaitingExceptionData function start');
        setLoading(true)
        axios({
            method: 'GET',
            url: `${baseUrl}/real-time/get-category-ticket-waiting-details/inner-data/branch/${props.selectedBranchId}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {

            console.log('getWaitingExceptionData success');
            let data = res.data.data;
            setLoading(false)
            if (data.tokenData !== []) {
                settokenData(data.tokenData);
                setCount(data.tokenData.length);
            }

            if (data.chartData !== []) {
                setchartData(data.chartData);
                loopChartData(data.chartData);
            }
            setChartValue(chartValue + 1);

        }).catch((error) => {
            console.log('getTicketIssuedDetails error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }

        })
    }

    const loopChartData = (data) => {
        const categories = [];
        const percentages = [];

        data.forEach(element => {
            categories.push(element.category);
            percentages.push(element.percentage);
        });

        setcategoryList(categories);
        setpercentageList(percentages);
    }

    const closeModal = () => {
        props.setShowWaitTimeExceptionDetails(false)
        props.setSticky(true)
        settokenData([]);
        setchartData([]);
    }

    return (
        <>
            {props.showWaitTimeExceptionDetails ?
                <div id="megamenu" className={`megamenu particles_js details-page open`}>
                    <span
                        onClick={() => {
                            closeModal();
                        }}
                        className="megamenu_toggle btn btn-danger"><i className="icon-close"></i></span>
                    <div className="container" style={{ marginTop: '3%' }}>

                        <div className="row clearfix">
                            <div className="col-12">
                                <div className="card">
                                    <div className="body">
                                        <div style={{ textAlign: 'center' }}>
                                            <h4>Wait Time Exceptions</h4>
                                            <small>{props.date}</small>
                                            <button className="btn btn-danger" style={{ float: 'right' }}
                                                onClick={() => {
                                                    closeModal();
                                                }}
                                            >Close</button>
                                        </div>
                                        <br></br>
                                        <div className="row clearfix">
                                            <div className="col-4">

                                                {
                                                    chartData.length !== 0 && chartValue > 0 ? <PersentageDonutChartWithBottomLegend
                                                        lable={categoryList} percentage={percentageList} chartValue={chartValue} />
                                                        :
                                                        <PersentageDonutChartWithBottomLegend
                                                            lable={[]} percentage={[]} chartValue={0} />
                                                }

                                                <div className='mt-4'>
                                                    <div style={{ overflowY: 'scroll', height: '200px' }}>
                                                        <table className="table table-hover table-custom">
                                                            <tbody>
                                                                {chartData.map((data, i) =>
                                                                    <tr key={i}>
                                                                        <td>{data.category}</td>
                                                                        <td>{data.waitExceptionsCount}</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-8">
                                                <div className="muidatatablecontainer">
                                                    {props.selectedBranchLevel === 4 ? (
                                                        <MUIDataTable
                                                            title={<>
                                                                <>
                                                                    <span className="badge badge-success ml-1 mb-2">{count}</span> Tickets Count.
                                                                </>
                                                                {/* {count}{count === 1 ? ' record' : ' records'}. */}
                                                                {isLoading &&
                                                                    <>&nbsp;&nbsp;&nbsp;<CircularProgress color="primary"
                                                                        size={20} /></>}
                                                            </>
                                                            }
                                                            data={tokenData}
                                                            columns={columns}
                                                            options={options}
                                                        />
                                                    ) : (
                                                        <MUIDataTable
                                                            title={<>
                                                                <>
                                                                    <span className="badge badge-success ml-1 mb-2">{count}</span> Tickets Count.
                                                                </>
                                                                {/* {count}{count === 1 ? ' record' : ' records'}. */}
                                                                {isLoading &&
                                                                    <>&nbsp;&nbsp;&nbsp;<CircularProgress color="primary"
                                                                        size={20} /></>}
                                                            </>
                                                            }
                                                            data={tokenData}
                                                            columns={columns_1}
                                                            options={options}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div id="particles-js"></div>
                </div>
                : null}
        </>
    );
}


export default WaitTimeExceptionDetails;